import React, { FC, ReactNode } from 'react'
import { IoMdArrowForward } from 'react-icons/io'
import { Link } from 'react-router-dom'

import styles from './ProgramCard.module.css'

import { colors } from 'Config'

const ProgramCard: FC<{ title: string; children: ReactNode; onClick: string }> = ({ title, children, onClick }) => {
  return (
    <Link to={onClick}>
      <div className={`${styles.card} mt-3`}>
        <div>
          <h4 className="mt-0">{title}</h4>
          <p className="mt-3 mb-1 pr-3">{children}</p>
        </div>
        <div className={`${styles.arrow}`}>
          <IoMdArrowForward size={'3rem'} color={colors.designSystem.gray2} />
        </div>
      </div>
    </Link>
  )
}

export default ProgramCard
